import { withConditionalComponent } from "src/HOC";
import FlightSelectWeb from "./layouts/FlightSelectNew.web";
import FlightSelectMob from "./layouts/FlightSelectNew.mob";
import { Form, Grid } from "antd";
import { MOBILE_BREAKPOINT_KEY } from "src/constants";
import { FC, useRef, useState } from "react";
import { useLazyGetAirPortsQuery } from "src/store/apis/Flights";
import { mapOption, MappedOptionType } from "./utils";
import { useDebounce } from "src/hooks/useDebounce";

const FlightSelectComponent = withConditionalComponent(FlightSelectWeb, FlightSelectMob);

const FlightSelect: FC<any> = ({ value, onChange, label, icon, className, closeSheet, ...rest }) => {
  const isLargeScreen = Grid.useBreakpoint()[MOBILE_BREAKPOINT_KEY];
  const [searchValue, setSearchValue] = useState<string>();
  const [getAirports, { isFetching, error }] = useLazyGetAirPortsQuery();
  const [options, setOptions] = useState<MappedOptionType[]>([]);
  const errors = Form.Item.useStatus().errors;
  const justSelectedRef = useRef(false);

  useDebounce(searchValue, {
    skipFirstRender: true,
    delay: 500,
    callBack: () => {
      if (justSelectedRef.current) {
        justSelectedRef.current = false;
        return;
      }
      if (!searchValue) return setOptions([]);
      getAirports({
        query: searchValue,
        limit: 10,
      }).then((res) => {
        setOptions(res.data?.airports.map(mapOption) ?? []);
      });
    },
  });

  const handleSearch = (value: string) => {
    setSearchValue(value);
  };

  const handleChange = (val: any) => {
    justSelectedRef.current = true;
    setSearchValue(val?.label);
    onChange?.(val);
    closeSheet?.();
  };

  return (
    <FlightSelectComponent
      trigger={isLargeScreen}
      props={{
        value,
        onChange: handleChange,
        label,
        icon,
        className,
        searchValue,
        isFetching,
        error,
        options,
        validationError:errors,
        onSearch: handleSearch,
        ...rest,
      }}
    />
  );
};

export default FlightSelect;
